import { useState, useEffect } from "react";
import { auth, db } from "../firebaseConfig";
import { collection, getDocs, query, where } from "firebase/firestore";

const useWardrobe = () => {
    const [wardrobe, setWardrobe] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchClothes = async () => {
            try {
                if (!auth.currentUser) {
                    if (process.env.NODE_ENV !== 'production') console.log("Aucun utilisateur connecté");
                    return;
                }

                const clothesCollection = collection(db, "clothes");
                const q = query(clothesCollection, where("userId", "==", auth.currentUser.uid));
                const clothesSnapshot = await getDocs(q);

                const clothesList = clothesSnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setWardrobe(clothesList);
            } catch (error) {
                console.error("Erreur :", error);
                setError("Erreur lors du chargement de la garde-robe");
            }
        };

        fetchClothes();
    }, []);

    return { wardrobe, error };
};

export default useWardrobe;
